export default "__VITE_ASSET__0S_dBoFH__"